import { AppState } from "./model";

export type SelectorState = AppState;

export const employeeRecordsSelector = (state: AppState) => state.employeeRecords;

export const basePathSelector = (state: AppState) =>
    state.router.pathname.substring(0, state.router.pathname.indexOf("employeeRecords") + "employeeRecords".length);
